<template>
  <div class="camp-tasks">
    <!-- 课程、考试、消息 -->
    <div class="task-tabs">
      <div
        class="tab-item"
        :class="{ cur: active === item.key }"
        v-for="item in tabs"
        :key="item.key"
        @click="changeTab(item.key)"
      >
        {{ item.label }}
        <img src="../../assets/images/zone/img2.png" v-if="active === item.key" class="icon1" alt="">
      </div>
    </div>
    <!-- 课程：医院单独一行，讲师和已完成人数同一行 -->
    <div class="task-panel" v-if="active === 'course'">
      <div class="task-state" v-if="!loading && !loadError && !currentList.length">暂无任务</div>
      <div class="task-item" v-for="item in currentList" :key="item.id">
        <img class="task-cover" :src="item.coverUrl || cover" :title="item.title" alt="" @click="goDetail(item)">
        <div class="task-main">
          <div class="task-title" @click="goDetail(item)">{{ item.title }}</div>
          <div class="task-desc" @click="goDetail(item)" v-if="item.desc">{{ item.desc }}</div>
          <div class="task-foot">
            <span class="task-desc" @click="goDetail(item)">讲师：{{ item.teacher || '-' }}</span>
            <span class="task-side" @click="goCompleted(item)">
              <span>已完成{{ item.done }}人</span>
              <i class="side-arrow"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- 考试：已完成人数在右下角 -->
    <div class="task-panel" v-else-if="active === 'exam'">
      <div class="task-state" v-if="!loading && !loadError && !currentList.length">暂无定制任务</div>
      <div class="task-item" v-for="item in currentList" :key="item.id">
        <div class="exam-mark" @click="goDetail(item)"><span>考试</span></div>
        <div class="task-main">
          <div class="task-title" @click="goDetail(item)">{{ item.title }}</div>
          <div class="task-foot">
            <span class="task-side" @click="goCompleted(item)">
              <span>已完成{{ item.done }}人</span>
              <i class="side-arrow"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- 消息：正文、时间，右侧箭头 -->
    <div class="task-panel is-message" v-else>
      <div class="task-state" v-if="!loading && !loadError && !currentList.length">暂无定制任务</div>
      <div class="msg-item" v-for="item in currentList" :key="item.id" @click="goDetail(item)">
        <div class="msg-text">{{ item.title }}</div>
        <div class="msg-foot">
          <span>{{ item.time }}</span>
          <i class="link-arrow"></i>
        </div>
      </div>
    </div>
    <div class="task-bar">
      <button type="button" @click="goCreate">创建任务</button>
    </div>
  </div>
</template>

<script>
import withRouteTracking from '@/utils/withRouteTracking'
import { getResearchCampDispatches } from '@/api/researchCamp'

const dispatchType = {
  course: 1,
  exam: 2,
  message: 3
}

const CampCustomTasks = {
  name: 'CampCustomTasks',
  data () {
    return {
      cover: require('@/assets/images/researchCamp/banner.png'),
      active: 'course',
      campConfigId: '',
      loading: false,
      loadError: '',
      loadSequence: 0,
      tabs: [
        { key: 'course', label: '课程' },
        { key: 'exam', label: '考试' },
        { key: 'message', label: '消息' }
      ],
      lists: { course: [], exam: [], message: [] }
    }
  },
  computed: {
    // 当前页签的任务列表
    currentList () {
      return this.lists[this.active] || []
    }
  },
  created () {
    this.campConfigId = this.$route.query.researchCampId || this.$route.query.campConfigId || ''
    if (dispatchType[this.$route.query.type]) this.active = this.$route.query.type
    this.loadList()
  },
  methods: {
    // 切换课程、考试、消息
    changeTab (key) {
      if (this.active === key) return
      this.active = key
      this.loadList()
    },
    // 按类型加载定制任务
    async loadList () {
      if (!this.campConfigId) {
        this.loadError = '未获取到研修营信息'
        this.$toast(this.loadError)
        return
      }
      const type = this.active
      const campConfigId = this.campConfigId
      const sequence = ++this.loadSequence
      this.loading = true
      this.loadError = ''
      try {
        const response = await getResearchCampDispatches(campConfigId, {
          contentType: dispatchType[type]
        })
        if (sequence === this.loadSequence) {
          const rows = response && Array.isArray(response.data) ? response.data : []
          this.$set(this.lists, type, rows.map(item => ({
            id: String(item.dispatchId),
            dispatchId: String(item.dispatchId),
            title: type === 'message' ? (item.messageContent || item.name || '') : (item.name || ''),
            desc: item.courseHospitalName || '',
            hospital: item.courseHospitalName || '',
            teacher: item.courseLecturerNames || '',
            coverUrl: item.coverUrl || '',
            done: Number(item.completedMemberCount) || 0,
            time: this.formatDateTime(item.createdAt)
          })))
        }
      } catch (error) {
        if (sequence === this.loadSequence) {
          this.$set(this.lists, type, [])
          this.loadError = (error && error.msg) || '定制任务加载失败'
          this.$toast(this.loadError)
        }
      } finally {
        if (sequence === this.loadSequence) this.loading = false
      }
    },
    // 创建时间格式化
    formatDateTime (value) {
      if (!value) return ''
      const date = new Date(Number(value))
      if (Number.isNaN(date.getTime())) return String(value)
      const pad = number => String(number).padStart(2, '0')
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`
    },
    // 进入定制任务详情
    goDetail (item) {
      this.$router.push({
        path: '/researchCamp/customTaskDetail',
        query: { dispatchId: item.dispatchId, type: this.active, researchCampId: this.campConfigId }
      })
    },
    // 查看已完成该课程或考试的学员
    goCompleted (item) {
      this.$router.push({
        path: '/researchCamp/completed',
        query: this.active === 'course'
          ? { dispatchId: item.dispatchId, campConfigId: this.campConfigId, viewRole: this.$route.query.viewRole }
          : { type: this.active, campConfigId: this.campConfigId, dispatchId: item.dispatchId, viewRole: this.$route.query.viewRole }
      })
    },
    // 新建当前类型的定制任务
    goCreate () {
      this.$router.push({
        path: '/researchCamp/customTaskCreate',
        query: { type: this.active, researchCampId: this.campConfigId }
      })
    }
  }
}

export default withRouteTracking(CampCustomTasks)
</script>

<style lang="less" scoped>
@import './camp.less';

.camp-tasks {
  .camp-page();
  padding-bottom: 90px;

  .task-tabs {
    display: flex;
    height: 44px;

    .tab-item {
      flex: 1;
      position: relative;
      line-height: 44px;
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      color: #000;

      &.cur {
        color: @camp-red;
        font-weight: 500;
      }

      .icon1 {
        position: absolute;
        left: 50%;
        bottom: 4px;
        width: 24px;
        transform: translateX(-50%);
      }
    }
  }

  .task-panel {
    .camp-white-card();
    padding: 4px 14px 8px;

    &.is-message {
      padding: 4px 18px 8px;
    }
  }

  .task-state {
    padding: 20px 0;
    text-align: center;
    color: #a39992;
    font-size: 13px;

    &.is-error {
      color: @camp-red;
    }
  }

  .task-item {
    display: flex;
    align-items: flex-start;
    padding: 14px 0;

    & + .task-item {
      border-top: 1px solid #f3f3f3;
    }
  }

  .exam-mark {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    margin-right: 10px;
    border-radius: 8px;
    background: #ff8d28;
    flex-shrink: 0;

    span {
      font-size: 13px;
      font-weight: 500;
      line-height: 18px;
      color: #fff;
    }
  }

  .task-cover {
    width: 100px;
    height: 58px;
    margin-right: 10px;
    border-radius: 5px;
    object-fit: cover;
    flex-shrink: 0;
  }

  .task-main {
    flex: 1;
    min-width: 0;
  }

  .task-title {
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    word-break: break-all;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #000;
  }

  .task-foot {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 20px;

    .task-desc {
      flex: 1;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .task-desc {
    font-size: 11px;
    font-weight: 400;
    line-height: 20px;
    color: #a39992;
  }

  .task-side {
    display: flex;
    align-items: center;
    margin-left: auto;
    font-size: 11px;
    font-weight: 300;
    line-height: 20px;
    color: #38C976;
    flex-shrink: 0;
  }

  .side-arrow {
    width: 4px;
    height: 4px;
    margin-left: 3px;
    border-top: 1px solid #A39992;
    border-right: 1px solid #A39992;
    transform: rotate(45deg);
    flex-shrink: 0;
  }

  .msg-item {
    padding: 12px 0 10px;

    & + .msg-item {
      border-top: 1px solid #f3f3f3;
    }
  }

  .msg-text {
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    word-break: break-word;
    color: #000;
  }

  .msg-foot {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 5px;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    color: #a39992;
  }

  .link-arrow {
    width: 5px;
    height: 5px;
    border-top: 1px solid #a39992;
    border-right: 1px solid #a39992;
    transform: rotate(45deg);
    flex-shrink: 0;
    margin-left: 2px;
  }

  .task-bar {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 14px 13px 24px;
    background: #fff;

    button {
      width: 100%;
      height: 42px;
      border: 0;
      border-radius: 30px;
      color: #fff;
      background: @camp-red;
      font-size: 14px;
      font-weight: 400;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/researchCamp/customTasks.vue